import { render, staticRenderFns } from "./cool.confirm.vue?vue&type=template&id=4182281d&scoped=true"
import script from "./cool.confirm.vue?vue&type=script&lang=js"
export * from "./cool.confirm.vue?vue&type=script&lang=js"
import style0 from "./cool.confirm.vue?vue&type=style&index=0&id=4182281d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182281d",
  null
  
)

export default component.exports